import React, { useEffect, useState } from 'react';
import '../../assets/style/ViewRemuneration.css';
import { RemunerationFilterType } from '../../utils/Types';
import {
  API_STATUS,
  DEFAULT_OPTION_LOCATION,
  DEFAULT_PAGE_SIZE,
} from '../../utils/Constant';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { Label, Row } from 'reactstrap';
import KTable from '../../components/KTable';
import KPagination from '../../components/KPagination';
import RemunerationFilter from '../../filters/RemunerationFilter';
import {
  onTableAction,
  toggleApproveModal,
  ViewRemunerationHeader,
} from './ViewRemunerationHelper';
import ViewRemunerationModal from '../modals/ViewRemunerationModal';
import {
  getRemunerationList,
  remunerationSelector,
} from '../../features/remunerationSlice';
import { formattedDateWithFormat } from '../../utils/Util';
import moment from 'moment';
import CenterSpinner from '../../components/CenterSpinner';
import ToggleSwitch from '../../components/ToggleSwitch';
import classNames from 'classnames';
import { useLoader } from '../../loader/LoaderProvider';

export const DefaultFilter = {
  zone: DEFAULT_OPTION_LOCATION,
  state: DEFAULT_OPTION_LOCATION,
  duration: moment().subtract(1, 'months').toDate(),
};

const ViewRemuneration: React.FunctionComponent = () => {
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedRemunerationDetails, setSelectedRemunerationDetails] =
    useState<any>('');
  const [isApproveModalOpen, setIsApproveModalOpen] = useState<boolean>(false);
  const [filterData, setFilterData] =
    useState<RemunerationFilterType>(DefaultFilter);
  const [selectedFilterData, setSelectedFilterData] =
    useState<RemunerationFilterType>(DefaultFilter);

  const { showLoader, setShowLoader } = useLoader();

  const pagination =
    useAppSelector(remunerationSelector).remunerationList.pagination;
  const dispatch = useAppDispatch();
  const apiStatus: string =
    useAppSelector(remunerationSelector).remunerationList.status;
  const [showFilter, setShowFilter] = useState<boolean>(true);

  const getRemunerationListData = () => {
    const data: any = {};
    if (selectedFilterData.zone?.value) {
      data.zone = selectedFilterData.zone.value;
    }
    if (selectedFilterData.state?.value) {
      data.state = selectedFilterData.state.value;
    }
    if (selectedFilterData.duration) {
      data.durationMonth = formattedDateWithFormat(
        String(selectedFilterData.duration),
        'MM-YYYY'
      );
    }
    data.pagePerCount = pageSize;
    data.pageNumber = currentPage;

    dispatch(getRemunerationList(data));
  };

  const tableData =
    useAppSelector(remunerationSelector).remunerationList.result;

  useEffect(() => {
    getRemunerationListData();
  }, [pageSize, currentPage, selectedFilterData]);

  useEffect(() => {
    if (apiStatus === API_STATUS.FAILED || apiStatus === API_STATUS.SUCCEEDED) {
      setShowLoader(false);
    } else if (apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    }
  }, [apiStatus]);

  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };

  return (
    <div className="remeneration-wrapper">
      <Label className="text-heading">View Remuneration</Label>
      <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />
      <div className="task-item-parent-view">
        {showFilter && (
          <RemunerationFilter
            filterData={filterData}
            setFilterData={setFilterData}
            onApplyFilters={() => {
              setCurrentPage(1);
              setSelectedFilterData(filterData);
            }}
            setSelectedFilterData={setSelectedFilterData}
          />
        )}

        <Row className="mt-3">
          <KTable
            data={tableData}
            tableParentClass={classNames('table-parent-remuneration', {
              hideFilters: !showFilter,
            })}
            columnHeader={ViewRemunerationHeader}
            isLoading={showLoader}
            onAction={(data: any, header: any) => {
              onTableAction(
                { data, header },
                setShowLoader,
                dispatch,
                selectedFilterData,
                getRemunerationListData,
                setSelectedRemunerationDetails,
                setIsApproveModalOpen
              );
            }}
          />
        </Row>
        {tableData.length > 0 && (
          <KPagination
            currentPage={pagination?.currentPage}
            pageSize={pagination?.pageSize}
            onPageChange={setCurrentPage}
            onSizeChange={setPageSize}
            fromItem={pagination.fromItem}
            toItem={pagination.toItem}
            totalItems={pagination?.totalItems}
          />
        )}
      </div>
      {isApproveModalOpen && (
        <ViewRemunerationModal
          isOpen={isApproveModalOpen}
          toggleApproveModal={(action: string) => {
            toggleApproveModal(
              action,
              getRemunerationListData,
              setIsApproveModalOpen
            );
          }}
          remunerationDetails={selectedRemunerationDetails}
          durationMonth={filterData.duration}
        />
      )}
      <CenterSpinner showLoader={showLoader} />
    </div>
  );
};

export default ViewRemuneration;
